import { useTheme } from "@mui/material/styles";
import { SharedChartStyles } from "@labs/shared/types/SharedChartStyles.ts";
import { figTreeFontFamily } from "../muiTheme.ts";

export const useSharedChartStyles = (): SharedChartStyles => {
  const theme = useTheme();
  return {
    colors: theme.palette.chartSeries,
    titleStyles: {
      fontSize: "1rem",
      fontWeight: "400",
      fontFamily: figTreeFontFamily,
      color: theme.palette.primary.dark,
    },
  };
};
